import { render } from "./SwdItemsPerPage.vue?vue&type=template&id=46938159"
import script from "./SwdItemsPerPage.vue?vue&type=script&lang=js"
export * from "./SwdItemsPerPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__